var currentLanguage =  'he';

var languages = [];

loadLanguage(currentLanguage);

function loadLanguage(language){
    languages[language] = require('./' + language + ".json");
}

export function getCurrentTextResource() {
    return languages[currentLanguage];
}

